import React, { useMemo } from 'react';
import styled from 'styled-components';

import Section from './Section';
import { SummaryAttachment, SummaryContentType } from './types';

function SummaryContent({ content }: { content: SummaryContentType | SummaryContentType[] }) {
  const items = useMemo(
    () => (!Array.isArray(content) ? [content] : content).filter((c) => c.text && c.text.trim().length > 0),
    [content]
  );

  return (
    <List>
      {items.map((item, idx) => (
        <ListItem key={`${item.text}-${idx}`}>
          {item.text}
          {item.children && <SummaryContent content={item.children} />}
        </ListItem>
      ))}
    </List>
  );
}

type Props = {
  title: string;
  attachments: SummaryAttachment[];
  content: SummaryContentType | SummaryContentType[];
};

export default function SummarySection({ title, attachments, content }: Props) {
  return (
    <Section title={title} attachments={attachments}>
      <SummaryContent content={content} />
    </Section>
  );
}

const List = styled.ul`
  list-style: disc;
  padding-left: 20px;
`;

const ListItem = styled.li`
  font-size: 12px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.black100};
  white-space: pre-line;
`;
